// /src/brands/horizon.js
export default {
  name: 'Horizon',

  theme: {
    typography: {
      fontFamily: "'Roboto', system-ui, -apple-system, sans-serif",

      baseFontSize: '15px',
      lineHeight: '1.25',
      headingScale: 1.0,

      googleFontUrl: 'https://fonts.googleapis.com/css2?' +
        'family=Roboto:wght@400;500;700&' +
        'family=Fira+Sans:wght@400;600;700&' +
        'display=swap'
    }
  },
}
